export const OT_DETAIL_CONSTANTS = {
    OT_STATUS: [
        {id:1 , name: "Creado"},
        {id:2 , name: "Pagado"},
        {id:3 , name: "Enviado"},
        {id:4 , name: "Recibido"},
        {id:5 , name: "Disputa"},
        {id:6 , name: "Finalizado"},
    ]
}